export default __webpack_public_path__ + "static/media/s2.2d291128.png";